
<script setup>

defineProps( [ 'heading', 'text', "reference" ] )

</script>

<template>

  <div class="border-t-8 border-t-[#373737] text-[#373737] min-h-45 shadow-md bg-white p-6 text-center flex flex-col gap-2">

    <h3 class="font-bold text-lg">{{ heading }}</h3>

     <p>

      <span v-html="text"></span>

      <span v-if="reference">
        
        <sup class="text-xs">{{ Array.isArray( reference ) ? reference.join( ',' ) : reference }}</sup>
      
      </span>

    </p>

  </div>

</template>